/**
 * モーダル動画再生
 */
import tingle from "tingle.js";

export default () => {
  const videoLinks = document.querySelectorAll(".js-modalVideo");
  if (!videoLinks) {
    return;
  }

  /**
   * modal
   */
  const videoModals = [];
  const videoModalsHtml = [];
  videoLinks.forEach((videoLink, index) => {
    const href = videoLink.href;
    const videoMeta = JSON.parse(videoLink.dataset.videometa);

    /**
     * urlの分解
     */
    const matchedFileName =
      href.match(
        /^(?:[^:\/?#]+:)?(?:\/\/[^\/?#]*)?(?:([^?#]*\/)([^\/?#]*))?(\?[^#]*)?(?:#.*)?$/
      ) ?? [];
    const [, dir, fileName, query] = matchedFileName.map(
      (match) => match ?? ""
    );
    const matchedExt = fileName.match(/^(.+?)(\.[^.]+)?$/) ?? [];
    const [, name, ext] = matchedExt.map((match) => match ?? "");

    /**
     * modal 設定
     */
    videoModals[index] = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeLabel: "CLOSE",
      closeMethods: ["overlay", "button"],
      cssClass: ["video-modal"],
      beforeClose: function () {
        return true;
      },
    });

    /**
     * modal html
     */
    let modalHtml = "";
    modalHtml += `<h3 class="video-modal__title">${videoMeta.title}</h3>`;
    modalHtml += '<div class="video">';
    modalHtml += `<video controls autoplay width="1024">`;
    modalHtml += `<source src="${
      window.location.origin + dir + name
    }.webm" type="video/webm">`;
    modalHtml += `<source src="${
      window.location.origin + dir + fileName
    }" type="video/mp4">`;
    modalHtml += "</video>";
    modalHtml += "</div>";
    videoModalsHtml[index] = modalHtml;

    /**
     * modal 開閉
     */
    videoLink.addEventListener("click", (event) => {
      event.preventDefault();
      videoModals[index].setContent(videoModalsHtml[index]);
      videoModals[index].open();
    });
  });
};
